module.exports = __webpack_public_path__ + "static/media/curate-images.10139757.png";